// Example class
let _this = (module.exports = {
  // Set the dom elements
  dom: {
    body: document.querySelector("body"),
  },

  // Set variables
  vars: {
    flag: false,
  },

  sticky: function () {
    const nav = document.querySelector(".navigation");
    if (!nav) return;

    const spacer = document.createElement("div");
    nav.parentNode.insertBefore(spacer, nav);

    let ticking = false;
    let isSticky = false;
    let exitTimer = null;

    function update() {
      const scrollY = window.scrollY;

      if (window.innerWidth <= 1024) {
        cleanup();
        ticking = false;
        return;
      }

      if (scrollY > 200 && !isSticky) {
        clearTimeout(exitTimer);
        isSticky = true;

        nav.classList.add("is-stuck");
        nav.classList.remove("is-opening");

        spacer.style.height = nav.offsetHeight + "px";

        setTimeout(() => {
          nav.classList.add("is-opening");
        }, 0);
      }

      if (scrollY <= 200 && isSticky) {
        isSticky = false;

        nav.classList.remove("is-stuck", "is-opening");
        spacer.style.height = "0px";
        clearTimeout(exitTimer);
      }

      ticking = false;
    }

    function cleanup() {
      clearTimeout(exitTimer);
      nav.classList.remove("is-stuck", "is-opening");
      spacer.style.height = "0px";
      isSticky = false;
    }

    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    });

    let resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 150);
    });
  },

  /**
   * Init functions
   */
  init: function () {
    this.sticky();
  },
});
